import { SystemEvent } from '@mbrtargeting/metatag-shared-types/metatag-core';
import { injectionTarget } from '../../../loader/decorators/inject.js';
import { triggerEvent } from '../../../loader/essentials/events.js';
import { logger } from '../../../loader/essentials/logger.js';

const log = logger.logGroup({ prefix: 'GlobalSettings' });

@injectionTarget()
export class GlobalSettings {

    private pageType: string = '';
    private zone: string = 'zoneError';
    private subZone: string = '';
    private adServerConsent: boolean | undefined = undefined;

    public setPageType(newPageType: string): void {
        const pageType = this.pageType = newPageType.toLowerCase();
        log.debug('pageType set to %o', [pageType]);
        triggerEvent(SystemEvent.SDG_PAGETYPE_SET, { pageType });
    }

    public getPageType(): string {
        return this.pageType;
    }

    public setZone(newZone: string): void {
        const zone = this.zone = newZone.toLowerCase();
        log.debug('zone set to %o', [zone]);
        triggerEvent(SystemEvent.SDG_ZONE_SET, { zone });
    }

    public getZone(): string {
        return this.zone;
    }

    public setSubZone(newSubZone: string): void {
        const subZone = this.subZone = newSubZone.toLowerCase();
        log.debug('subZone set to %o', [subZone]);
    }

    public getSubZone(): string {
        return this.subZone;
    }

    public setAdServerConsent(adServerConsent: boolean) {
        this.adServerConsent = adServerConsent;
    }

    public getAdServerConsent(): boolean | undefined {
        return this.adServerConsent;
    }
}
